module.exports = __webpack_public_path__ + "static/media/spinner-solid-full.37ae67d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spinner-solid-full.svg
// module id = 374
// module chunks = 0